import * as $ from "jquery";
import {EpMap} from "../../../map/map";
import {GroupHuntingLocationEditorContextMenu} from "../../../map/menu/GroupHuntingLocationEditorContextMenu";
import {fromLonLat, toLonLat} from "ol/proj";
import {confirmModal} from "../../../confirmModal";
import {groupHuntingLocationPoints} from "./points";
import {EpInventoryLocations} from "../../../map/layers/inventory-locations";
import {InventoryLocationInteractionsHandler} from "./interactions";
import {closeModal, openModal} from "../../../utilities";
import {groupHuntingLocationDevices} from "./devices-points";
import Feature from 'ol/Feature.js';
import {
    Pointer as PointerInteraction,
} from 'ol/interaction.js';
import axios from "axios";
import {toastAlert} from "../../../toastAlert";
import {HunterPointsLayer} from "../../../map/layers/hunter-points";
import {nanoid} from "nanoid";
import {emptyForm, enableFormBack, handleApiForm} from "../../../forms";

export const locationsManagementPage = () => {
    let inventoryLocationsMapContainer = $('.grouphunting-locations-map');
    inventoryLocationsMapContainer.height($(document).height() - 116);
    const target = inventoryLocationsMapContainer.attr('id');

    const body = $('body');

    // Prevent from submitting with "enter" keyboard
    $(window).keydown(function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });

    const form = body.find('#addHuntingLocation, #editHuntingLocation');


    $('#btnSaveLocations').on('click', function(e) {
        let coords = $('input[name="coordinates"]').val().trim();

        if (!coords) {
            e.preventDefault();
            let myModal = new bootstrap.Modal(document.getElementById('customAlert'), {
                keyboard: false
            });
            myModal.show();
        }
    });


    /// Setup map
    let epMap = new EpMap({target, ruler: true});
    epMap.contextMenu = new GroupHuntingLocationEditorContextMenu(epMap);

    // Setup locations layer
    let locationsLayer = null;
    if (typeof window._locations != 'undefined') {
        let locations = JSON.parse(window._locations);

        if (/edit\/locations.*?\/(edit)/.test(window.location.href)) {
            let match = window.location.href.match(/edit\/locations\/(.*?)\/(edit)/);
            locations = locations.filter(location => parseInt(location.id) !== parseInt(match[1]));
        }

        // locations layer
        locationsLayer = new EpInventoryLocations(epMap.map);
        epMap.changeStyleUnderZoom(locationsLayer)

        for (let location of locations) {
            locationsLayer.addFeature(location.coordinates, {
                fields: {
                    name: location.name
                }
            });
        }

        epMap.addCustomLayer(locationsLayer);
    }

    // Setup boundaries layer
    epMap.addBoundariesLayer();
    if (typeof window._boundaries != 'undefined') {
        let boundaries = JSON.parse(window._boundaries);
        $('[name="district_id"]').change(function() {
            epMap.boundaries.getSource().clear();
            const id = parseInt($(this).val());

            const el = boundaries.find(b => parseInt(b.district_id) === id);
            if(el && el.coordinates) {
                epMap.boundaries.addFeature(el.coordinates);
                epMap.boundaries.fitInView();
            }
        }).change()
    }

    // Setup sectors layer
    epMap.addSectorsLayer();
    if (typeof window._sectors != 'undefined') {
        epMap.sectors.addSectorsFromObject(JSON.parse(window._sectors));
    }

    let devicesEpLayer = epMap.addDevicesLayer();
    let devices = JSON.parse(window._devices ?? '[]');
    devicesEpLayer.addDevicesFromObject(devices);

    epMap.hideLabelsIfNecessary(devicesEpLayer);

    const coordinatesInput = form.find('[name="coordinates"]')

    let interactionsHandler = new InventoryLocationInteractionsHandler(epMap);


    window._interactionsHandler = interactionsHandler;


    $('#btnGenerateBasedOnDistrict').click(async function () {
        let feature = interactionsHandler
            .interactions
            .location
            .features[0] ?? null;


        const boundaries = JSON.parse(window._boundaries);
        const el = boundaries.find(b => parseInt(b.district_id) === parseInt($('[name="district_id"]').val()));
        if(!el || !el.coordinates) {
            return;
        }

        if (!feature) {
            coordinatesInput.val(el.coordinates);

            interactionsHandler.interactions.location.createFeatureFromInput();
            interactionsHandler.interactions.location.updateAreaInfo();

            return;
        }

        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz zmienić granicę obszaru?');
        if (!confirm) return;

        let points = el.coordinates.split(' ')
        let coordinatesArray = [points.filter(coords => coords !== "").map(coord => fromLonLat(coord.split(",")))];
        feature.getGeometry().setCoordinates(coordinatesArray);

        interactionsHandler.interactions.location.updateFeature(feature);
        interactionsHandler.interactions.location.updateAreaInfo();
    })

    interactionsHandler.interactions.location.setEnabled(true);

    interactionsHandler.interactions.observers_line.setEnabled(true);

    interactionsHandler.interactions.beaters_line.setEnabled(true);

    let hunterPointsEpLayer = epMap.addHunterPointsLayer();
    epMap.hunterPointsEpLayer = hunterPointsEpLayer;

    groupHuntingLocationPoints(epMap);
    groupHuntingLocationDevices(epMap);

    let hunterPoints = JSON.parse(window._hunterPoints ?? '[]');
    hunterPointsEpLayer.addHuntersPointsFromObject(hunterPoints);
    hunterPointsEpLayer.getLayer().setZIndex(1000);

    epMap.hideLabelsIfNecessary(hunterPointsEpLayer);

    $('input[name="zone_depth"]').change(function() {
        if($('#custom_zone_depth').is(':checked')) {
            $("#custom_zone_depth_input").attr('disabled', false)
        } else {
            $("#custom_zone_depth_input").attr('disabled', true)
        }
    }).change()

    let editAreaTypeFeatureId = null;
    let editAreaInteractionObject = null;
    body.on('click', '.btnEditAreaType', function() {
        $('.error[data-for="edit_area_type"]').text('');

        editAreaTypeFeatureId = $(this).data('app-feature_id');
        const type = parseInt($(this).data('app-area_type'));

        const select = $('#editAreaTypeModal select[name="edit_area_type"]');
        select.val(type)

        if($(this).data('app-map_interaction_area_type') === 'thermal_imaging_areas') {
            editAreaInteractionObject = interactionsHandler.interactions.thermal_imaging_areas;
        } else {
            editAreaInteractionObject = interactionsHandler.interactions.thermal_imaging_transects;
        }

        openModal('#editAreaTypeModal');
    })

    body.on('click', '#btnEditAreaTypeEdit', function() {
        const select = $('#editAreaTypeModal select[name="edit_area_type"]');
        const selected = parseInt(select.val());

        // update text
        $(`[data-app-map_interaction_area_type][data-app-feature_id="${editAreaTypeFeatureId}"]`)
            .text(selected === 2 ? 'polny' : 'leśny')
            .data('app-area_type', selected)

        // update input
        $(`[name="thermal_imaging_area_types[${editAreaTypeFeatureId}]"][data-app-map_interaction_input="thermal_imaging_area_types"]`)
            .val(selected);

        // update feature
        if(editAreaInteractionObject) {
            let feature = editAreaInteractionObject.features.find(feature => feature.get('id') == editAreaTypeFeatureId);
            if(feature) {
                feature.set('area_type', selected);
            }

            editAreaInteractionObject.updateAreaInfo();
        }

        closeModal('#editAreaTypeModal')
    })

    $('[name="district_id"]').change(function() {
        $('[name="hidden_district_id"]').val($(this).val())
    }).change();


    if (parseInt($('#addHuntingLocation_hunting_type_id').children("option:selected").val()) === 1) {
        $(".no-type-info").hide();
        $(".type-info").show();
        $(".bigArea").hide();
        $(".traditional").show();
    }
    else if (parseInt($('#addHuntingLocation_hunting_type_id').children("option:selected").val()) === 2){
        $(".no-type-info").hide();
        $(".type-info").show();
        $(".bigArea").show();
        $(".traditional").hide();
    }
    else{
        $(".type-info").hide();
        $(".no-type-info").show();
    }


    $('#addHuntingLocation_hunting_type_id').on('change', async function (e) {
        e.preventDefault();

        if (parseInt($(this).children("option:selected").val()) === 1) {
            $(".no-type-info").hide();
            $(".type-info").show();
            $(".bigArea").hide();
            $(".traditional").show();

        } else if (parseInt($(this).children("option:selected").val()) === 2)  {
            $(".no-type-info").hide();
            $(".type-info").show();
            $(".bigArea").show();
            $(".traditional").hide();
        }
        else{
            $(".type-info").hide();
            $(".no-type-info").show();
        }

    });

    if (parseInt($('#editHuntingLocation_hunting_type_id').children("option:selected").val()) === 1) {

        $(".no-type-info").hide();
        $(".type-info").show();
        $(".bigArea").hide();
        $(".traditional").show();

        $('#editHuntingLocation_hunting_type_id').attr('disabled', 'disabled');
    }
    else if (parseInt($('#editHuntingLocation_hunting_type_id').children("option:selected").val()) === 2){

        $(".no-type-info").hide();
        $(".type-info").show();
        $(".bigArea").show();
        $(".traditional").hide();

        $('#editHuntingLocation_hunting_type_id').attr('disabled', 'disabled');
    }
    else{

        $(".type-info").hide();
        $(".no-type-info").show();
    }

    $('#editHuntingLocation_hunting_type_id').on('change', async function (e) {
        e.preventDefault();

        $('input[name="observers_count"]').val(0).change();
        $('input[name="beaters_count"]').val(0).change();

        if (parseInt($(this).children("option:selected").val()) === 1) {

            $(".no-type-info").hide();
            $(".type-info").show();
            $(".bigArea").hide();
            $(".traditional").show();

        } else if (parseInt($(this).children("option:selected").val()) === 2)  {

            $(".no-type-info").hide();
            $(".type-info").show();
            $(".bigArea").show();
            $(".traditional").hide();
        }
        else{

            $(".type-info").hide();
            $(".no-type-info").show();
        }

    });


    class Drag extends PointerInteraction {
        constructor() {
            super({
                handleDownEvent: handleDownEvent,
                handleDragEvent: handleDragEvent,
                handleMoveEvent: handleMoveEvent,
                handleUpEvent: handleUpEvent,
            });

            /**
             * @type {import("../src/ol/coordinate.js").Coordinate}
             * @private
             */
            this.coordinate_ = null;

            /**
             * @type {string|undefined}
             * @private
             */
            this.cursor_ = 'pointer';

            /**
             * @type {Feature}
             * @private
             */
            this.feature_ = null;

            /**
             * @type {string|undefined}
             * @private
             */
            this.previousCursor_ = undefined;
        }
    }


    function handleDownEvent(evt) {
        const map = evt.map;

        const features = map.getFeaturesAtPixel(evt.pixel, {
            hitTolerance: 5,
        }).filter(feature => {
            const type = feature.get('type');
            return type === 'beater' || type === 'observer';
        });

        if (features.length > 0) {
            const feature = features[0];
            this.coordinate_ = evt.coordinate;
            this.feature_ = feature;
        }

        return features.length > 0;
    }

    function handleDragEvent(evt) {
        const deltaX = evt.coordinate[0] - this.coordinate_[0];
        const deltaY = evt.coordinate[1] - this.coordinate_[1];

        const geometry = this.feature_.getGeometry();
        geometry.translate(deltaX, deltaY);

        const updatedCoordinates = toLonLat(geometry.getCoordinates()).join(',');

        const featureType = this.feature_.get('type');

        let currentSpots;
        if (featureType === 'beater') {
            currentSpots = $('input[name="beaters_spots"]').val();
        } else if (featureType === 'observer') {
            currentSpots = $('input[name="observers_spots"]').val();
        }

        let spotList = currentSpots.split(' ').filter(Boolean)

        function coordinatesMatch(coord1, coord2) {
            const [lon1, lat1] = coord1.split(',').map(parseFloat);
            const [lon2, lat2] = coord2.split(',').map(parseFloat);
            const tolerance = 0.001;
            return Math.abs(lon1 - lon2) < tolerance && Math.abs(lat1 - lat2) < tolerance;
        }

        const currentFeatureCoordinates = toLonLat(geometry.getCoordinates()).join(',');

        const spotIndex = spotList.findIndex(spot => coordinatesMatch(spot, currentFeatureCoordinates));

        if (spotIndex !== -1) {
            spotList[spotIndex] = updatedCoordinates;
        }

        const updatedSpots = spotList.join(' ');
        if (featureType === 'beater') {
            $('input[name="beaters_spots"]').val(updatedSpots);
        } else if (featureType === 'observer') {
            $('input[name="observers_spots"]').val(updatedSpots);
        }

        this.coordinate_[0] = evt.coordinate[0];
        this.coordinate_[1] = evt.coordinate[1];
    }


    /**
     * @param {import("../src/ol/MapBrowserEvent.js").default} evt Event.
     */
    function handleMoveEvent(evt) {
        if (this.cursor_) {
            const map = evt.map;
            const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
            });
            const element = evt.map.getTargetElement();
            if (feature) {
                if (element.style.cursor != this.cursor_) {
                    this.previousCursor_ = element.style.cursor;
                    element.style.cursor = this.cursor_;
                }
            } else if (this.previousCursor_ !== undefined) {
                element.style.cursor = this.previousCursor_;
                this.previousCursor_ = undefined;
            }
        }
    }

    function handleUpEvent() {
        this.coordinate_ = null;
        this.feature_ = null;
        return false;
    }

    const dragInteraction = new Drag();
    epMap.getOlMap().addInteraction(dragInteraction);


    const locationHuntingPointForm = $('#huntersLocationPointFormHunting');

    const container = $('[data-app-map_interaction_container="hunters"]')
    const table = container.find('table').DataTable();

    const container2 = $('[data-app-map_interaction_container="devices"]')
    const table2 = container2.find('table').DataTable()


    table.on('click', '.btnEditHunterPoint', function() {
        const modal = $('#hunterModal');

        modal.find('.modal-title').text('Edycja stanowiska myśliwego');

        const id = $(this).attr('data-id');

        const name = $(`[name="hunters[${id}][name]"]`).val();
        const latitude = $(`[name="hunters[${id}][latitude]"]`).val();
        const longitude = $(`[name="hunters[${id}][longitude]"]`).val();
        const type = $(`[name="hunters[${id}][type]"]`).val();
        const device_id = $(`[name="hunters[${id}][device_id]"]`).val();
        // const isNew = $(`[name="points[${id}][is_new]"]`).val();

        modal.find('[name="id"]').val(id)
        modal.find('[name="name"]').val(name)
        modal.find('[name="latitude"]').val(latitude)
        modal.find('[name="longitude"]').val(longitude)
        modal.find('[name="type"]').val(type)
        modal.find('[name="device_id"]').val(device_id)
        modal.find('[name="is_new"]').val(false)

        openModal('#hunterModal');
    })



    table.on('click', '.btnDeleteHunterPoint', async function() {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć stanowisko myśliwego?', {color: 'danger'});
        if (!confirm) return;

        const id = $(this).attr('data-id');


        try {
            const response = await axios.post(window._DELETE_HUNTER_POINT_URL.replace('REPLACE_ID', id));

            if (response.data.code !== 200) {
                throw new Error();
            }

            let feature = hunterPointsEpLayer
                .getSource()
                .getFeatures()
                .find(feature => feature.get('id') == id);


            if(feature) {
                hunterPointsEpLayer
                    .getSource()
                    .removeFeature(feature);
            }
            else{
                let feature = hunterPointsEpLayer
                    .getSource()
                    .getFeatures()
                    .find(feature => feature.get('point_id') == id);


                if(feature) {
                    hunterPointsEpLayer
                        .getSource()
                        .removeFeature(feature);
                }
            }


            $(`[name="hunters[${id}][name]"]`).remove();
            $(`[name="hunters[${id}][latitude]"]`).remove();
            $(`[name="hunters[${id}][longitude]"]`).remove();
            $(`[name="hunters[${id}][is_new]"]`).remove();

            const row = table.$(`tr[data-id="${id}"]`);
            table.api().row(row).remove().draw();


            toastAlert('Pomyślnie usunięto stanowisko myśliwego');
        } catch (err) {
            toastAlert('Wystąpił błąd podczas próby usunięcia stanowiska myśliwego', {type: 'danger'})
        }
    })


    // $(document).ready(function () {
    //     $('#btnAddHuntersOnDevices').on('click', async function (e) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //
    //         const uid = $(this).attr('data-id');
    //
    //         console.log("ddd");
    //         try {
    //
    //             const response = await axios.post(window._ADD_HUNTERS_ON_DEVICES.replace('REPLACE_ID', uid));
    //
    //             if (response.data.code !== 200) {
    //                 throw new Error();
    //             }
    //
    //             response.data.spots.forEach(spot => {
    //                 let id = spot.id;
    //
    //                 $('body').append(`
    //                 <input type="hidden" name="hunters[${id}][name]" value="${spot.name}" />
    //                 <input type="hidden" name="hunters[${id}][latitude]" value="${spot.latitude}" />
    //                 <input type="hidden" name="hunters[${id}][longitude]" value="${spot.longitude}" />
    //                 <input type="hidden" name="hunters[${id}][type]" value="${spot.type}" />
    //                 <input type="hidden" name="hunters[${id}][device_id]" value="${spot.device_id}" />
    //                  <input type="hidden" name="hunters[${id}][id]" value="${id}" />
    //             `);
    //
    //                 let row = $(`
    //             <tr data-id="${spot.id}">
    //                 <td class="hunter-name">${spot.name}</td>
    //                 <td>
    //                     <button data-id="${spot.id}" type="button" class="btn btn-sm btn-primary btnEditHunterPoint">Edytuj</button>
    //                     <button data-id="${spot.id}" type="button" class="btn btn-sm btn-danger btnDeleteHunterPoint">Usuń</button>
    //                 </td>
    //             </tr>
    //         `);
    //
    //                 table.api().rows.add(row);
    //                 table.api().draw();
    //
    //                 let feature = hunterPointsEpLayer.addFeature([
    //                     parseFloat(String(spot.longitude)),
    //                     parseFloat(String(spot.latitude))
    //                 ]);
    //
    //                 feature.set('id', spot.id);
    //                 feature.set('name', spot.name);
    //                 feature.set('device_type', spot.type ? spot.type : 1);
    //                 feature.set('device_id', spot.device_id);
    //
    //             });
    //
    //             toastAlert('Pomyślnie dodano stanowiska myśliwych');
    //         } catch (err) {
    //             toastAlert('Wystąpił błąd podczas dodania stanowisk myśliwych', {type: 'danger'});
    //         }
    //     });
    // });

    let tempId = nanoid();
    locationHuntingPointForm.submit(function(e) {
        e.preventDefault();

        let formData = new FormData(this);

        if(formData.get('id').length > 0) {
            // editing..
            tempId = formData.get('id');

            let feature = hunterPointsEpLayer
                .getSource()
                .getFeatures()
                .find(feature => String(feature.get('point_id')) === String(tempId));

            hunterPointsEpLayer
                .getSource()
                .removeFeature(feature);


            if(feature) {

                let device_feature = epMap.locationDevicesLayer
                    .getSource()
                    .getFeatures()
                    .find(device_feature => device_feature.get('id') == feature.get('device_id'));

                if (device_feature) {
                    device_feature.set('name', formData.get('name'));
                     table2.$(`tr[data-id="${device_feature.get('id')}"]`).find('.device-name').text(formData.get('name'))
                }
            }

            feature = hunterPointsEpLayer
                .getSource()
                .getFeatures()
                .find(feature => String(feature.get('id')) === String(tempId));

            hunterPointsEpLayer
                .getSource()
                .removeFeature(feature);

            if(feature) {

                let device_feature = epMap.locationDevicesLayer
                    .getSource()
                    .getFeatures()
                    .find(device_feature => device_feature.get('id') == feature.get('device_id'));


                if (device_feature) {
                    device_feature.set('name', formData.get('name'));
                    table2.$(`tr[data-id="${device_feature.get('id')}"]`).find('.device-name').text(formData.get('name'))
                }
            }

            // feature = hunterPointsEpLayer
            //     .getSource()
            //     .getFeatures()
            //     .find(feature => feature.id_ == tempId);
            //
            //
            // if(feature) {
            //     hunterPointsEpLayer
            //         .getSource()
            //         .removeFeature(feature);
            // }
            //
            // if(feature) {
            //
            //     let device_feature = epMap.locationDevicesLayer
            //         .getSource()
            //         .getFeatures()
            //         .find(device_feature => device_feature.get('id') == feature.get('device_id'));
            //
            //     console.log(device_feature);
            //
            //     if (device_feature) {
            //         device_feature.set('name', formData.get('name'));
            //         // table2.$(`tr[data-id="${spot_feature.get('point_id')}"]`).find('.hunter-name').text(formData.get('name'))
            //     }
            // }


            $(`[name="hunters[${tempId}][name]"]`).val(formData.get('name'))
            $(`[name="hunters[${tempId}][latitude]"]`).val(formData.get('latitude'))
            $(`[name="hunters[${tempId}][longitude]"]`).val(formData.get('longitude'))
            $(`[name="hunters[${tempId}][type]"]`).val(formData.get('type'))
            $(`[name="hunters[${tempId}][device_id]"]`).val(formData.get('device_id'))

            table.$(`tr[data-id="${tempId}"]`).find('.hunter-name').text(formData.get('name'))
        } else {
            form.append(`<input type="hidden" name="hunters[${tempId}][name]" value="${formData.get('name')}" />`)
            form.append(`<input type="hidden" name="hunters[${tempId}][latitude]" value="${formData.get('latitude')}" />`)
            form.append(`<input type="hidden" name="hunters[${tempId}][longitude]" value="${formData.get('longitude')}" />`)
            form.append(`<input type="hidden" name="hunters[${tempId}][type]" value="${formData.get('type')}" />`)
            form.append(`<input type="hidden" name="hunters[${tempId}][device_id]" value="${formData.get('device_id')}" />`)


            let row = $(`
                <tr data-id="${tempId}">
                    <td class="hunter-name">${formData.get('name')}</td>
                    <td>
                        <button data-id="${tempId}" type="button" class="btn btn-sm btn-primary btnEditHunterPoint">
                            Edytuj
                        </button>
                        <button data-id="${tempId}" type="button" class="btn btn-sm btn-danger btnDeleteHunterPoint">
                            Usuń
                        </button>
                    </td>
                </tr>
            `)

            table.api().rows.add(row);
            table.api().draw();
        }

        let feature = hunterPointsEpLayer.addFeature([
            parseFloat(String(formData.get('longitude'))),
            parseFloat(String(formData.get('latitude')))
        ]);

        feature.set('id', tempId);
        feature.set('name', formData.get('name'));
        feature.set('device_type', formData.get('type'));
        feature.set('device_id', formData.get('device_id'));

        enableFormBack(this);
        closeModal('#hunterModal');
    })

    handleApiForm('#huntersLocationPointFormHunting', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#hunterModal');
            emptyForm(form);
            toastAlert('Pomyślnie dodano stanowisko');
        }
    })

}